<template>
  <van-dialog
    use-slot
    v-model="showDialog"
    show-cancel-button
    :use-title-slot="true"
    :showConfirmButton="false"
    :showCancelButton="false"
    :class="[
      'coupon-popup-dialog',
      isDesktop ? 'desktop-layout' : 'mobile-layout',
      bgClassName,
      displayHorizontal ? 'horizontal' : '',
    ]"
    :closeOnClickOverlay="closeOnClickOverlay"
    @close="handleClose"
  >
    <template>
      <section class="coupon-popup-body">
        <img
          :class="['popup-left-img', bgClassName]"
          :src="
            require(`@/assets/images/activities/coupon/${
              bgClassName === 'plural'
                ? 'coupon-gift-left-double'
                : 'coupon-gift-left-one'
            }.png`)
          "
          alt="icon"
        />
        <template v-if="showName">
          <p class="coupon-name">{{ activityInfo.activityName }}</p>
          <div v-show="activityInfo.activityDesc" class="coupon-sub-name">
            <p>{{ activityInfo.activityDesc }}</p>
          </div>
        </template>
        <template v-else>
          <p class="coupon-name canWrap">
            {{ $t('coupon.congratulationsCoupon') }}
          </p>
        </template>
        <ul :class="['coupon-list-wrapper', bgClassName]">
          <li
            :class="['coupon-item', bgClassName]"
            v-for="item in couponList"
            :key="item.id"
          >
            <template>
              <!-- 立减券  -->
              <p class="coupon-price" v-if="item.couponType * 1 === 1">
                <money-display
                  :useConfig="true"
                  :data="{ number: item.couponPrice, currency: item.currency }"
                  :needHandle="true"
                />
              </p>
              <!-- 折扣券  -->
              <p class="coupon-price" v-else>
                {{ 100 - item.couponDiscount + '%OFF' }}
              </p>
              <p class="coupon-title">
                {{ $t('coupon.coupon') }}
              </p>
            </template>
          </li>
        </ul>
        <CouponLoginBtn
          v-if="!(userInfo && userInfo.kicoinId)"
          @login="login"
          :page="page"
          :buttonValue="buttonValue"
          :activityId="activityInfo.activityId"
        />
        <template><slot name="footDesc"></slot></template>
      </section>
      <van-icon
        :name="isDesktop ? 'clear' : 'close'"
        :color="isDesktop ? 'rgba(255, 255, 255, 0.72)' : '#fff6f699'"
        size="32"
        class="close-coupon-popup"
        @click="hidePopup"
      />
    </template>
  </van-dialog>
</template>

<script>
  import MoneyDisplay from '@/components/MoneyDisplay'
  import CouponLoginBtn from '@/components/CouponLoginBtn'
  import couponMixins from '@/mixins/coupon'
  import { mapState, mapGetters, mapMutations } from 'vuex'

  export default {
    mixins: [couponMixins],
    props: {
      dataSource: {
        type: Object,
        default: () => {},
      },
      show: {
        type: Boolean,
        default: false,
      },
      showName: {
        type: Boolean,
        default: true,
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      page: {
        type: String,
        default: '',
      },
      buttonValue: {
        type: String,
        default: '',
      },
    },
    components: {
      MoneyDisplay,
      CouponLoginBtn,
    },
    data() {
      return {
        showDialog: this.show,
      }
    },
    watch: {
      show(val) {
        this.showDialog = val
        const { activityId } = this.activityInfo
        this.$emit('popupShow', { show: val, activityId })
      },
    },
    computed: {
      ...mapState(['userInfo', 'isDesktop']),
      ...mapGetters(['displayHorizontal']),
      activityInfo() {
        return this.dataSource.activity || {}
      },
      couponList() {
        return this.dataSource.couponList || []
      },
      bgClassName() {
        const len = this.couponList.length
        if (len > 0) {
          return len === 1 ? 'single' : len === 2 ? 'double' : 'plural'
        } else {
          return 'empty'
        }
      },
    },
    methods: {
      ...mapMutations(['setLoginFromCouponPop']),
      hidePopup() {
        this.$emit('close')
      },
      handleClose() {
        this.$emit('close')
      },
      login(res) {
        this.$emit('close')
        this.setLoginFromCouponPop(res)
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
